module.exports = __webpack_public_path__ + "static/media/avatar4.a80a5d55.jpeg";